// extracted by mini-css-extract-plugin
export default {"btn_scroll":"style_btn_scroll__Gm6Vu"};